import { RouterProvider } from "react-router-dom";
import { mobileRouter } from "./mobile";
import { ModeSwitchOverlay } from "../components/ModeSwitchOverlay";

export {
  RequireAuth,
  RequireStep,
  selectCompletedSteps,
  selectCurrentPatientId,
  selectIsAuthenticated,
} from "./guards";

export const AppRouter = () => {
  return (
    <>
      <RouterProvider router={mobileRouter} />
      <ModeSwitchOverlay />
    </>
  );
};
